/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_loading_text11 = /** @type {(inputs: {}) => string} */ () => {
	return `Loading`
};

const fr_loading_text11 = /** @type {(inputs: {}) => string} */ () => {
	return `Chargement`
};

const de_loading_text11 = /** @type {(inputs: {}) => string} */ () => {
	return `Laden`
};

const es_loading_text11 = /** @type {(inputs: {}) => string} */ () => {
	return `Cargando`
};

const it_loading_text11 = /** @type {(inputs: {}) => string} */ () => {
	return `Caricamento`
};

const ar_loading_text11 = /** @type {(inputs: {}) => string} */ () => {
	return `تحميل`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const loading_text11 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.loading_text11(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("loading_text11", locale)
	if (locale === "en") return en_loading_text11(inputs)
	if (locale === "fr") return fr_loading_text11(inputs)
	if (locale === "de") return de_loading_text11(inputs)
	if (locale === "es") return es_loading_text11(inputs)
	if (locale === "it") return it_loading_text11(inputs)
	return ar_loading_text11(inputs)
};
export { loading_text11 as "LOADING_TEXT" }